import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import { addLocaleData } from 'react-intl'

export default () => {
  addLocaleData([...es, ...fr])
}
